export interface FileManagerHandlers {
  renameItem: (itemId: string, newName: string) => void;
  deleteItem: (itemId: string) => void;
}

export interface UploadContext {
  sessionId: string | null;
  workspaceId: string;
  portalId: string;
  pageId?: string;
  blockId?: string;
  target?: string;
}

export const PortalAllowedFileTypes = ['portalPage', 'portalBlock', 'portalFiles', 'note', 'task', 'comment'];
